import { AnalyticsEvent, emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

export const isAnalyticsEvent = (event: unknown): event is AnalyticsEvent => {
  return ['eventName', 'consentPurpose', 'concept'].every((item) => !!event?.[item]);
};

/**
 * A generic Higher-Order Function to wrap an event handler with analytics tracking.
 *
 * @param event - The analytics event object to be emitted.
 * @param callback - The original event handler function to be called after tracking.
 * @returns A new event handler function that first emits the analytics event
 * and then executes the original callback.
 */
export const withEventTracking = <T extends (...args: any[]) => any>(
  event: unknown,
  callback?: T
) => {
  return (...args: Parameters<T>): void => {
    if (event && isAnalyticsEvent(event)) {
      emitAnalyticsEvent(event);
    }

    callback?.(...args);
  };
};
